import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const CATEGORIES = [
  "Tüm Ürünler",
  "Burgerler",
  "Menüler & Kombolar",
  "Çıtır Lezzetler",
  "İçecekler",
  "Tatlılar",
  "Soslar",
];

// categories available for the admin form (excludes "Tüm Ürünler")
export const PRODUCT_CATEGORIES = CATEGORIES.slice(1);

export const resolveImage = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};

export const formatTL = (n) => {
  const v = Number(n || 0);
  const whole = Number.isInteger(Math.round(v * 100) / 100);
  return new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(v);
};

// İndirim uygulanmış temel fiyat (ekstra/içecek hariç)
export const effectivePrice = (product) => {
  const base = product?.price || 0;
  if (!product?.discount_active || !product?.discount_value) return base;
  let p = base;
  if (product.discount_type === "amount") p = base - product.discount_value;
  else p = base * (1 - product.discount_value / 100);
  return Math.max(0, Math.round(p * 100) / 100);
};

export const hasDiscount = (product) =>
  !!product?.discount_active && !!product?.discount_value && effectivePrice(product) < (product?.price || 0);

// Yemek platformları (paket servis fiyatlandırması için)
export const DELIVERY_PLATFORMS = [
  { key: "yemeksepeti", label: "Yemeksepeti" },
  { key: "getir", label: "Getir" },
  { key: "trendyol", label: "Trendyol" },
  { key: "migros", label: "Migros" },
];

// Seçili platforma göre paket servis fiyatı: platform > varsayılan paket servis > kiosk
export const platformPrice = (product, platformKey) => {
  const pp = product?.platform_prices || {};
  if (platformKey && platformKey !== "standart" && pp[platformKey] > 0) return pp[platformKey];
  if (product?.delivery_price && product.delivery_price > 0) return product.delivery_price;
  return product?.price || 0;
};

export const getBranchCode = () =>
  (new URLSearchParams(window.location.search).get("sube") || "").trim().toUpperCase();

export const api = axios.create({ baseURL: API });

export const getToken = () => localStorage.getItem("fb_token");
export const setToken = (t) => {
  if (t) localStorage.setItem("fb_token", t);
  else localStorage.removeItem("fb_token");
};

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Herkese açık sipariş sayfası için (auth token EKLEMEZ)
export const publicApi = axios.create({ baseURL: API });
